const countryList = [
    {val:'af',name:'Afghanistan', code3:'AFG', tz:'Asia/Kabul'},
    {val:'ax',name:'Åland Islands', code3:'ALA'},
    {val:'al',name:'Albania', code3:'ALB', tz:'Europe/Tirane'},
    {val:'dz',name:'Algeria', code3:'DZA', tz:'Africa/Algiers'},
    {val:'as',name:'American Samoa', code3:'ASM', tz:'US/Samoa'},
    {val:'ad',name:'Andorra', code3:'AND', tz:'Europe/Andorra'},
    {val:'ao',name:'Angola', code3:'AGO', tz:'Africa/Luanda'},
    {val:'ai',name:'Anguilla', code3:'AIA', tz:'America/Anguilla'},
    {val:'aq',name:'Antarctica', code3:'ATA', tz:'Antarctica/Palmer'},
    {val:'ag',name:'Antigua and Barbuda', code3:'ATG', tz:'America/Antigua'},
    {val:'ar',name:'Argentina', code3:'ARG', tz:'America/Argentina/Catamarca'},
    {val:'am',name:'Armenia', code3:'ARM', tz:'Asia/Yerevan'},
    {val:'aw',name:'Aruba', code3:'ABW', tz:'America/Aruba'},
    {val:'au',name:'Australia', code3:'AUS', tz:'Australia/ACT'},
    {val:'at',name:'Austria', code3:'AUT', tz:'Europe/Vienna'},
    {val:'az',name:'Azerbaijan', code3:'AZE', tz:'Asia/Baku'},
    {val:'bs',name:'Bahamas', code3:'BHS', tz:'America/Nassau'},
    {val:'bh',name:'Bahrain', code3:'BHR', tz:'Asia/Bahrain'},
    {val:'bd',name:'Bangladesh', code3:'BGD', tz:'Asia/Dhaka'},
    {val:'bb',name:'Barbados', code3:'BRB', tz:'America/Barbados'},
    {val:'by',name:'Belarus', code3:'BLR', tz:'Europe/Minsk'},
    {val:'be',name:'Belgium', code3:'BEL', tz:'Europe/Brussels'},
    {val:'bz',name:'Belize', code3:'BLZ', tz:'America/Belize'},
    {val:'bj',name:'Benin', code3:'BEN', tz:'Africa/Porto-Novo'},
    {val:'bm',name:'Bermuda', code3:'BMU', tz:'Atlantic/Bermuda'},
    {val:'bt',name:'Bhutan', code3:'BTN', tz:'Asia/Thimphu'},
    {val:'bo',name:'Bolivia', code3:'BOL', tz:'America/La_Paz'},
    {val:'bq',name:'Bonaire, Sint Eustatius and Saba', code3:'BES', tz:'US/Eastern'},
    {val:'ba',name:'Bosnia and Herzegovina', code3:'BIH', tz:'Europe/Sarajevo'},
    {val:'bw',name:'Botswana', code3:'BWA', tz:'Africa/Gaborone'},
    {val:'bv',name:'Bouvet Island', code3:'BVT', tz:'Arctic/Longyearbyen'},
    {val:'br',name:'Brazil', code3:'BRA', tz:'Brazil/East'},
    {val:'io',name:'British Indian Ocean Territory', code3:'IOT', tz:'Indian/Chagos'},
    {val:'bn',name:'Brunei Darussalam', code3:'BRN', tz:'Asia/Brunei'},
    {val:'bg',name:'Bulgaria', code3:'BGR', tz:'Europe/Sofia'},
    {val:'bf',name:'Burkina Faso', code3:'BFA', tz:'Africa/Ouagadougou'},
    {val:'bi',name:'Burundi', code3:'BDI', tz:'Africa/Bujumbura'},
    {val:'kh',name:'Cambodia', code3:'KHM', tz:'Asia/Phnom_Penh'},
    {val:'cm',name:'Cameroon', code3:'CMR', tz:'Africa/Douala'},
    {val:'ca',name:'Canada',code3:'CAN', tz:'Canada/Eastern'},
    {val:'cv',name:'Cape Verde', code3:'CPV', tz:'Atlantic/Cape_Verde'},
    {val:'ky',name:'Cayman Islands', code3:'CYM', tz:'America/Cayman'},
    {val:'cf',name: 'Central African Republic', code3:'CAF', tz:'Africa/Bangui'},
    {val:'td',name:'Chad', code3:'TCD', tz:'Africa/Ndjamena'},
    {val:'cl',name:'Chile', code3:'CHL', tz:'Chile/EasterIsland'},
    {val:'cn',name:'China', code3: 'CHN', tz:'Asia/Shanghai'},
    {val:'cx',name:'Christmas Island', code3:'CXR', tz:'Indian/Christmas'},
    {val:'cc',name:'Cocos (Keeling) Islands', code3:'CCK', tz:'Indian/Cocos'},
    {val:'co',name:'Colombia', code3:'COL', tz:'America/Bogota'},
    {val:'km',name:'Comoros', code3:'COM', tz:'Indian/Comoro'},
    {val:'cd',name:'Congo, Democratic Republic of', code3:'COD', tz:'Africa/Lubumbashi'},
    {val:'cg',name:'Congo, Republic of', code3:'COG', tz:'Africa/Lubumbashi'},
    {val:'ck',name:'Cook Islands', code3:'COK', tz:'Pacific/Rarotonga'},
    {val:'cr',name:'Costa Rica', code3:'CRI', tz:'America/Costa_Rica'},
    {val:'hr',name:'Croatia', code3:'HRV', tz:'Europe/Zagreb'},
    {val:'cu',name:'Cuba', code3:'CUB', tz:'Cuba'},
    {val:'cw',name:'Curaçao', code3:'CUW', tz:'America/Curacao'},
    {val:'cy',name:'Cyprus', code3:'CYP', tz:'Asia/Nicosia'},
    {val:'cz',name:'Czech Republic', code3:'CZE', tz:'Europe/Prague'},
    {val:'ci',name:'Cote D\'Ivoire', code3:'CIV', tz:'Africa/Abidjan'},
    {val:'dk',name:'Denmark', code3:'DNK', tz:'Europe/Copenhagen'},
    {val:'dj',name:'Djibouti', code3:'DJI', tz:'Africa/Djibouti'},
    {val:'do',name:'Dominican Republic', code3:'DOM', tz:'America/Santo_Domingo'},
    {val:'dm',name:'Dominica', code3:'DMA', tz:'America/Dominica'},
    {val:'ec',name:'Ecuador', code3:'ECU', tz:'Pacific/Galapagos'},
    {val:'eg',name:'Egypt', code3:'EGY', tz:'Egypt'},
    {val:'sv',name:'El Salvador', code3:'SLV', tz:'America/El_Salvador'},
    {val:'gq',name:'Equatorial Guinea', code3:'GNQ', tz:'America/Guadeloupe'},
    {val:'er',name:'Eritrea', code3:'ERI', tz:'Africa/Asmara'},
    {val:'ee',name:'Estonia', code3:'EST', tz:'Europe/Tallinn'},
    {val:'sz',name:'Eswatini', code3:'SWZ', tz:'Africa/Johannesburg'},
    {val:'et',name:'Ethiopia', code3:'ETH', tz:'Africa/Addis_Ababa'},
    {val:'fk',name:'Falkland Islands (Malvinas)', code3:'FLK', tz:'Atlantic/Stanley'},
    {val:'fo',name:'Faroe Islands', code3:'FRO', tz:'Atlantic/Faroe'},
    {val:'fj',name:'Fiji', code3:'FJI', tz:'Pacific/Fiji'},
    {val:'fi',name:'Finland', code3:'FIN', tz:'Pacific/Fiji'},
    {val:'fr',name:'France', code3:'FRA', tz:'Europe/Paris'},
    {val:'gf',name:'French Guiana', code3:'GUF', tz:'Atlantic/Bermuda'},
    {val:'pf',name:'French Polynesia', code3:'PYF', tz:'Pacific/Fakaofo'},
    {val:'tf',name:'French Southern Territories', code3:'ATF', tz:'Atlantic/Bermuda'},
    {val:'ga',name:'Gabon', code3:'GAB', tz:'Africa/Libreville'},
    {val:'gm',name:'Gambia', code3:'GMB', tz:'Africa/Banjul'},
    {val:'ge',name:'Georgia', code3:'GEO', tz:'Atlantic/South_Georgia'},
    {val:'de',name:'Germany', code3:'DEU', tz:'Europe/Berlin'},
    {val:'gh',name:'Ghana', code3:'GHA', tz:'Africa/Accra'},
    {val:'gi',name:'Gibraltar', code3:'GIB', tz:'Europe/Gibraltar'},
    {val:'gr',name:'Greece', code3:'GRC', tz:'Europe/Athens'},
    {val:'gl',name:'Greenland', code3:'GRL', tz:'America/Scoresbysund'},
    {val:'gd',name:'Grenada', code3:'GRD', tz:'America/Grenada'},
    {val:'gp',name:'Guadeloupe', code3:'GLP', tz:'America/Guadeloupe'},
    {val:'gu',name:'Guam', code3:'GUM', tz:'Pacific/Guam'},
    {val:'gt',name:'Guatemala', code3:'GTM', tz:'America/Guatemala'},
    {val:'gg',name:'Guernsey', code3:'GGY', tz:'Europe/London'},
    {val:'gn',name:'Guinea', code3:'GIN', tz:'Africa/Conakry'},
    {val:'gw',name:'Guinea-Bissau', code3:'GNB', tz:'Africa/Bissau'},
    {val:'gy',name:'Guyana', code3:'GUY', tz:'America/Guyana'},
    {val:'ht',name:'Haiti', code3:'HTI', tz:'America/Port-au-Prince'},
    {val:'hm',name:'Heard Island and McDonald Islands', code3:'HMD', tz:'Pacific/Palau'},
    {val:'va',name:'Holy See (Vatican City State)', code3:'VAT', tz:'Europe/Vatican'},
    {val:'hn',name:'Honduras', code3:'HND', tz:'America/Tegucigalpa'},
    {val:'hk',name:'Hong Kong', code3:'HKG', tz:'Asia/Hong_Kong'},
    {val:'hu',name:'Hungary', code3:'HUN', tz:'Europe/Budapest'},
    {val:'is',name:'Iceland', code3:'ISL', tz:'Iceland'},
    {val:'in',name:'India', code3: 'IND', tz:'Asia/Kolkata'},
    {val:'id',name:'Indonesia', code3:'IDN', tz:'Asia/Pontianak'},
    {val:'ir',name:'Iran', code3:'IRN', tz:'Asia/Tehran'},
    {val:'iq',name:'Iraq', code3:'IRQ', tz:'Asia/Baghdad'},
    {val:'ie',name:'Ireland', code3:'IRL', tz:'Europe/Dublin'},
    {val:'im',name:'Isle of Man', code3:'IMN', tz:'Europe/Isle_of_Man'},
    {val:'il',name:'Israel', code3:'ISR', tz:'Asia/Jerusalem'},
    {val:'it',name:'Italy', code3:'ITA', tz:'Europe/Rome'},
    {val:'jm',name:'Jamaica', code3:'JAM', tz:'America/Jamaica'},
    {val:'jp',name:'Japan', code3:'JPN', tz:'Asia/Tokyo'},
    {val:'je',name:'Jersey', code3:'JEY', tz:'Europe/Jersey'},
    {val:'jo',name:'Jordan', code3:'JOR', tz:'Asia/Amman'},
    {val:'kz',name:'Kazakhstan', code3:'KAZ', tz:'Asia/Almaty'},
    {val:'ke',name:'Kenya', code3:'KEN', tz:'Africa/Nairobi'},
    {val:'ki',name:'Kiribati', code3:'KIR', tz:'Pacific/Kiritimati'},
    {val:'kp',name:'Korea (the Democratic People\'s Republic of)', code3:'PRK', tz:'Pacific/Palau'},
    {val:'kr',name:'Korea (the Republic of)', code3:'KOR', tz:'Pacific/Palau'},
    {val:'kw',name:'Kuwait', code3:'KWT', tz:'Asia/Kuwait'},
    {val:'kg',name:'Kyrgyzstan', code3:'KGZ', tz:'Asia/Bishkek'},
    {val:'la',name:'Laos', code3:'LAO', tz:'Asia/Vientiane'},
    {val:'lv',name:'Latvia', code3:'LVA', tz:'Europe/Riga'},
    {val:'lb',name:'Lebanon', code3:'LBN', tz:'Asia/Beirut'},
    {val:'ls',name:'Lesotho', code3:'LSO', tz:'Africa/Maseru'},
    {val:'lr',name:'Liberia', code3:'LBR', tz:'Africa/Monrovia'},
    {val:'ly',name:'Libyan Arab Jamahiriya', code3:'LBY', tz:'Africa/Tripoli'},
    {val:'li',name:'Liechtenstein', code3:'LIE', tz:'Europe/Vaduz'},
    {val:'lt',name:'Lithuania', code3:'LTU', tz:'Europe/Vilnius'},
    {val:'lu',name:'Luxembourg', code3:'LUX', tz:'Europe/Luxembourg'},
    {val:'mo',name:'Macao', code3:'MAC', tz:'Asia/Macau'},
    {val:'mk',name:'Macedonia', code3:'MKD', tz:'Europe/Skopje'},
    {val:'mg',name:'Madagascar', code3:'MDG', tz:'Indian/Antananarivo'},
    {val:'mw',name:'Malawi', code3:'MWI', tz:'Africa/Blantyre'},
    {val:'my',name:'Malaysia', code3:'MYS', tz:'Asia/Kuala_Lumpur'},
    {val:'mv',name:'Maldives', code3:'MDV', tz:'Indian/Maldives'},
    {val:'ml',name:'Mali', code3:'MLI', tz:'Africa/Bamako'},
    {val:'mt',name:'Malta', code3:'MLT', tz:'Europe/Malta'},
    {val:'mh',name:'Marshall Islands', code3:'MHL', tz:'Pacific/Majuro'},
    {val:'mq',name:'Martinique', code3:'MTQ', tz:'America/Martinique'},
    {val:'mr',name:'Mauritania', code3:'MRT', tz:'Africa/Nouakchott'},
    {val:'mu',name:'Mauritius', code3:'MUS', tz:'Indian/Mauritius'},
    {val:'yt',name:'Mayotte', code3:'MYT', tz:'Indian/Mayotte'},
    {val:'mx',name:'Mexico', code3:'MEX', tz:'America/Mexico_City'},
    {val:'fm',name:'Micronesia (Federated States of)', code3:'FSM', tz:'Pacific/Guam'},
    {val:'md',name:'Moldova', code3:'MDA', tz:'Europe/Chisinau'},
    {val:'mc',name:'Monaco', code3:'MCO', tz:'Europe/Monaco'},
    {val:'mn',name:'Mongolia', code3:'MNG', tz:'Asia/Choibalsan'},
    {val:'me',name:'Montenegro', code3:'MNE', tz:'Europe/Podgorica'},
    {val:'ms',name:'Montserrat', code3:'MSR', tz:'America/Montserrat'},
    {val:'ma',name:'Morocco', code3:'MAR', tz:'Africa/Casablanca'},
    {val:'mz',name:'Mozambique', code3:'MOZ', tz:'Africa/Maputo'},
    {val:'mm',name:'Myanmar', code3:'MMR', tz:'Asia/Rangoon'},
    {val:'na',name:'Namibia', code3:'NAM', tz:'Africa/Windhoek'},
    {val:'nr',name:'Nauru', code3:'NRU', tz:'Pacific/Nauru'},
    {val:'np',name:'Nepal', code3:'NPL', tz:'Asia/Kathmandu'},
    {val:'nl',name:'Netherlands', code3:'NLD', tz:'Europe/Amsterdam'},
    {val:'nc',name:'New Caledonia', code3:'NCL', tz:'Pacific/Noumea'},
    {val:'nz',name:'New Zealand', code3:'NZL', tz:'Pacific/Auckland'},
    {val:'ni',name:'Nicaragua', code3:'NIC', tz:'America/Managua'},
    {val:'ne',name:'Niger', code3:'NER', tz:'Africa/Niamey'},
    {val:'nu',name:'Niue', code3:'NIU', tz:'Pacific/Niue'},
    {val:'nf',name:'Norfolk Island', code3:'NFK', tz:'Pacific/Norfolk'},
    {val:'ng',name:'Nigeria', code3:'NGA', tz:'Africa/Lagos'},
    {val:'kp',name:'North Korea', code3:'KOR', tz:'Asia/Pyongyang'},
    {val:'mp',name:'Northern Mariana Islands', code3:'MNP', tz:'Pacific/Saipan'},
    {val:'no',name:'Norway', code3:'NOR', tz:'Europe/Oslo'},
    {val:'om',name:'Oman', code3:'OMN', tz:'Asia/Muscat'},
    {val:'pk',name:'Pakistan', code3:'PAK', tz:'Asia/Karachi'},
    {val:'pw',name:'Palau', code3:'PLW', tz:'Pacific/Palau'},
    {val:'ps',name:'Palestine', code3:'PSE', tz:'Asia/Hebron'},
    {val:'pa',name:'Panama', code3:'PAN', tz:'America/Panama'},
    {val:'pg',name:'Papua New Guinea', code3:'PNG', tz:'Pacific/Bougainville'},
    {val:'py',name:'Paraguay', code3:'PRY', tz:'America/Asuncion'},
    {val:'pe',name:'Peru', code3:'PER', tz:'America/Lima'},
    {val:'ph',name:'Philippines', code3:'PHL', tz:'Asia/Manila'},
    {val:'pn',name:'Pitcairn', code3:'PCN', tz:'Pacific/Pitcairn'},
    {val:'pl',name:'Poland', code3:'POL', tz:'Europe/Warsaw'},
    {val:'pt',name:'Portugal', code3:'PRT', tz:'Atlantic/Madeira'},
    {val:'pr',name:'Puerto Rico', code3:'PRI', tz:'America/Puerto_Rico'},
    {val:'qa',name:'Qatar', code3:'QAT', tz:'Asia/Qatar'},
    {val:'re',name:'Réunion', code3:'REU', tz:'Indian/Reunion'},
    {val:'ro',name:'Romania', code3:'ROU', tz:'Europe/Bucharest'},
    {val:'ru',name:'Russia', code3:'RUS', tz:'Asia/Anadyr'},
    {val:'rw',name:'Rwanda', code3:'RWA', tz:'Africa/Kigali'},
    {val:'bl',name:'Saint Barthélemy', code3:'BLM', tz:'America/St_Barthelemy'},
    {val:'sh',name:'Saint Helena, Ascension and Tristan da Cunha', code3:'SHN', tz:'Atlantic/St_Helena'},
    {val:'kn',name:'Saint Kitts And Nevis', code3:'KNA', tz:'America/St_Kitts'},
    {val:'lc',name:'Saint Lucia', code3:'LCA', tz:'America/St_Lucia'},
    {val:'mf',name:'Saint Martin (French part)', code3:'MAF', tz:'US/Eastern'},
    {val:'pm',name:'Saint Pierre and Miquelon', code3:'SPM', tz:'America/Miquelon'},
    {val:'vc',name:'Saint Vincent And The Grenedines', code3:'VCT', tz:'America/St_Vincent'},
    {val:'ws',name:'Samoa', code3:'WSM', tz:'Pacific/Apia'},
    {val:'sm',name:'San Marino', code3:'SMR', tz:'Europe/San_Marino'},
    {val:'st',name:'Sao Tome And Principe', code3:'STP', tz:'Africa/Sao_Tome'},
    {val:'sa',name:'Saudi Arabia', code3:'SAU', tz:'Asia/Riyadh'},
    {val:'sn',name:'Senegal', code3:'SEN', tz:'Africa/Dakar'},
    {val:'rs',name:'Serbia', code3:'SRB', tz:'Europe/Belgrade'},
    {val:'sc',name:'Seychelles', code3:'SYC', tz:'Indian/Mahe'},
    {val:'sl',name:'Sierra Leone', code3:'SLE', tz:'Africa/Freetown'},
    {val:'sg',name:'Singapore', code3:'SGP', tz:'Asia/Singapore'},
    {val:'sx',name:'Sint Maarten', code3:'', tz:'America/Lower_Princes'},
    {val:'sk',name:'Slovakia', code3:'SVK', tz:'Europe/Bratislava'},
    {val:'si',name:'Slovenia', code3:'SVN', tz:'Europe/Ljubljana'},
    {val:'sb',name:'Solomon Islands', code3:'SLB', tz:'Pacific/Guadalcanal'},
    {val:'so',name:'Somalia', code3:'SOM', tz:'Africa/Mogadishu'},
    {val:'za',name:'South Africa', code3:'ZAF', tz:'Africa/Johannesburg'},
    {val:'gs',name:'South Georgia and the South Sandwich Islands', code3:'SGS', tz:'Atlantic/South_Georgia'},
    {val:'ss',name:'South Sudan', code3:'SSD', tz:'Africa/Cairo'},
    {val:'es',name:'Spain', code3: 'ESP', tz:'Europe/Madrid'},
    {val:'lk',name:'Sri Lanka', code3:'LKA', tz:'Asia/Colombo'},
    {val:'sd',name:'Sudan', code3:'SDN', tz:'Africa/Khartoum'},
    {val:'sr',name:'Suriname', code3:'SUR', tz:'America/Paramaribo'},
    {val:'sj',name:'Svalbard and Jan Mayen', code3:'SJM', tz:'Europe/Oslo'},
    {val:'se',name:'Sweden', code3:'SWE', tz:'Europe/Stockholm'},
    {val:'ch',name:'Switzerland', code3:'CHE', tz:'Europe/Zurich'},
    {val:'sy',name:'Syrian Arab Republic', code3:'SYR', tz:'Asia/Damascus'},
    {val:'tw',name:'Taiwan', code3:'TWN', tz:'Asia/Taipei'},
    {val:'tj',name:'Tajikistan', code3:'TJK', tz:'Asia/Dushanbe'},
    {val:'tz',name:'Tanzania', code3:'TZA', tz:'Africa/Dar_es_Salaam'},
    {val:'th',name:'Thailand', code3:'THA', tz:'Asia/Bangkok'},
    {val:'tl',name:'Timor-Leste', code3:'TLS', tz:'Asia/Dili'},
    {val:'tg',name:'Togo', code3:'TON', tz:'Africa/Lome'},
    {val:'tk',name:'Tokelau', code3:'TKL', tz:'Pacific/Tongatapu'},
    {val:'to',name:'Tonga', code3:'TON', tz:'Pacific/Tongatapu'},
    {val:'tt',name:'Trinidad and Tobago', code3:'TTO', tz:'America/Port_of_Spain'},
    {val:'tn',name:'Tunisia', code3:'TUN', tz:'Africa/Tunis'},
    {val:'tr',name:'Turkey', code3:'TUR', tz:'Europe/Istanbul'},
    {val:'tm',name:'Turkmenistan', code3:'TMN', tz:'Asia/Ashgabat'},
    {val:'tc',name:'Turks and Caicos Islands', code3:'TCA', tz:'America/Grand_Turk'},
    {val:'tv',name:'Tuvalu', code3:'TUV', tz:'Pacific/Funafuti'},
    {val:'ug',name:'Uganda', code3:'UGA', tz:'Africa/Kampala'},
    {val:'ua',name:'Ukraine', code3:'UKR', tz:'Europe/Simferopol'},
    {val:'ae',name:'United Arab Emirates', code3:'ARE', tz:'Asia/Dubai'},
    {val:'gb',name:'United Kingdom', code3:'GBR', tz:'Europe/London'},
    {val:'um',name:'United States Minor Outlying Islands', code3:'UMI', tz:'US/Hawaii'},
    {val:'us',name:'United States', code3:'USA', tz:'America/New_York'},
    {val:'uy',name:'Uruguay', code3:'URY', tz:'America/Montevideo'},
    {val:'uz',name:'Uzbekistan', code3:'UZB', tz:'Asia/Samarkand'},
    {val:'vu',name:'Vanuatu', code3:'VUT', tz:'Pacific/Efate'},
    {val:'ve',name:'Venezuela', code3:'VEN', tz:'America/Caracas'},
    {val:'vn',name:'Viet Nam', code3:'VNM', tz:'Asia/Ho_Chi_Minh'},
    {val:'vg',name:'Virgin Islands (British)', code3:'VGB', tz:'America/Tortola'},
    {val:'vi',name:'Virgin Islands (U.S.)', code3:'VIR', tz:'America/Virgin'},
    {val:'wf',name:'Wallis and Futuna', code3:'WLF', tz:'Pacific/Wallis'},
    {val:'eh',name:'Western Sahara', code3:'ESH', tz:'Africa/Casablanca'},
    {val:'ye',name:'Yemen', code3:'YEM', tz:'Asia/Aden'},
    {val:'zm',name:'Zambia', code3:'ZMB', tz:'Africa/Lusaka'},
    {val:'zw',name:'Zimbabwe', code3:'ZWE', tz:'Africa/Harare'}
];

module.exports = countryList;